import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import api from '../../../../api/client';
import ListPagination, {paginateItems} from '../../../CustomInputs/ListPagination';

class CleaningArchive extends Component {
    state = {
        name: '',
        from: '',
        to: '',
        rows: [],
        loading: false,
        searched: false,
        listPage: 1,
        pageSize: 30,
        error: '',
    };

    search = async () => {
        this.setState({loading: true, error: '', listPage: 1});
        try {
            const params = {};
            if (this.state.name.trim()) params.name = this.state.name.trim();
            if (this.state.from.trim()) params.from = this.state.from.trim();
            if (this.state.to.trim()) params.to = this.state.to.trim();
            const data = await api.get('/api/v1/supervisor/record/cleaning/archive', {params}).then(r => r.data);
            this.setState({
                rows: Array.isArray(data) ? data : [],
                loading: false,
                searched: true,
            });
        } catch (e) {
            this.setState({
                loading: false,
                searched: true,
                rows: [],
                error: 'جستجوی آرشیو نظافت ناموفق بود',
            });
        }
    };

    summaryByPerson = () => {
        const map = new Map();
        for (const row of this.state.rows) {
            const id = row.personId || row.personName || 'unknown';
            if (!map.has(id)) {
                map.set(id, {
                    personId: row.personId,
                    personName: row.personName || 'نامشخص',
                    nationalCode: row.nationalCode,
                    count: Number(row.personCountInRange) || 0,
                });
            }
        }
        return Array.from(map.values()).sort((a, b) => b.count - a.count || String(a.personName).localeCompare(String(b.personName), 'fa'));
    };

    render() {
        const summary = this.summaryByPerson();
        const paged = paginateItems(this.state.rows, this.state.listPage, this.state.pageSize);
        const pageRows = paged.pageItems || [];
        return (
            <>
                <div className="page-title-row">
                    <h4>آرشیو نظافت شبانه</h4>
                    <div className="page-actions">
                        <Link className="back-btn" to="/dashboard/PresenceAbsence">
                            بازگشت
                            <i className="bi bi-caret-left-fill"/>
                        </Link>
                    </div>
                </div>

                <div className="search-box search-toolbar mb-3">
                    <div className="search-field search-field-grow">
                        <span className="search-field-label">نام / کد ملی</span>
                        <input
                            className="form-control"
                            type="search"
                            placeholder="مثلاً نام اقامتگر"
                            value={this.state.name}
                            onChange={(e) => this.setState({name: e.target.value})}
                            onKeyDown={(e) => e.key === 'Enter' && this.search()}
                        />
                    </div>
                    <div className="search-field">
                        <span className="search-field-label">از تاریخ</span>
                        <input
                            className="form-control"
                            type="text"
                            dir="ltr"
                            placeholder="1403/01/01"
                            value={this.state.from}
                            onChange={(e) => this.setState({from: e.target.value})}
                        />
                    </div>
                    <div className="search-field">
                        <span className="search-field-label">تا تاریخ</span>
                        <input
                            className="form-control"
                            type="text"
                            dir="ltr"
                            placeholder="1403/12/29"
                            value={this.state.to}
                            onChange={(e) => this.setState({to: e.target.value})}
                        />
                    </div>
                    <div className="search-field">
                        <button className="btn-done my-0" type="button" disabled={this.state.loading} onClick={this.search}>
                            {this.state.loading ? 'در حال جستجو...' : 'جستجو'}
                        </button>
                    </div>
                </div>

                {this.state.error ? <div className="alert alert-danger">{this.state.error}</div> : null}

                {this.state.searched && summary.length > 0 ? (
                    <div className="table-box mb-4">
                        <h5 className="mb-2">جمع‌بندی نفرات در بازه</h5>
                        <table className="table">
                            <thead>
                            <tr>
                                <th>نام</th>
                                <th>کد ملی</th>
                                <th>تعداد نوبت نظافت</th>
                            </tr>
                            </thead>
                            <tbody>
                            {summary.map((s) => (
                                <tr key={s.personId || s.personName}>
                                    <td>{s.personName}</td>
                                    <td>{s.nationalCode || '—'}</td>
                                    <td>{s.count}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                ) : null}

                <div className="table-box">
                    <h5 className="mb-2">جزئیات ثبت‌ها</h5>
                    <table className="table">
                        <thead>
                        <tr>
                            <th>تاریخ</th>
                            <th>نام</th>
                            <th>کد ملی</th>
                            <th>تعداد در بازه</th>
                        </tr>
                        </thead>
                        <tbody>
                        {!this.state.searched ? (
                            <tr><td colSpan={4}>برای مشاهده آرشیو، جستجو کنید (بدون فیلتر همه‌ی نظافت‌ها می‌آید).</td></tr>
                        ) : pageRows.length === 0 ? (
                            <tr><td colSpan={4}>موردی یافت نشد.</td></tr>
                        ) : pageRows.map((r) => (
                            <tr key={r.recordId}>
                                <td>{r.date}</td>
                                <td>{r.personName || '—'}</td>
                                <td>{r.nationalCode || '—'}</td>
                                <td>{r.personCountInRange}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    {paged.totalPages > 1 ? (
                        <ListPagination
                            totalPages={paged.totalPages}
                            page={paged.page}
                            onNewPage={(listPage) => this.setState({listPage})}
                        />
                    ) : null}
                </div>
            </>
        );
    }
}

export default CleaningArchive;
